export default {
  on: 'ON',
  off: 'OFF',
  unknown: 'UNKNOWN',
};
